import makeService from './api';

export default makeService('connexion_users');
